<main class="weMain">
	<app-header />

	<div [ngClass]="fullWidth ? '' : errorPages ? 'weErrorPage' : 'weContainer'">
		<router-outlet />
	</div>

	<!-- Toast notifications -->
	<app-toast-container />
</main>

<app-footer />
